const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

export {
    AUTH_LOCAL_STORAGE_KEY
}